/**
 * Resolve with `promise` if it settles within `ms`, otherwise reject with a
 * TimeoutError.
 *
 * IMPORTANT: this does NOT cancel the underlying operation — the original
 * promise keeps running (e.g. KRGlue.loadLibrary keeps polling for window.KR).
 * Callers MUST guard against a late resolution of the original acting after the
 * timeout (we do this with a generation/mounted guard in PayzenCardForm).
 */
export class TimeoutError extends Error {
  constructor(message = 'Operation timed out') {
    super(message);
    this.name = 'TimeoutError';
  }
}

export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    let settled = false;
    const timer = setTimeout(() => {
      if (!settled) {
        settled = true;
        reject(new TimeoutError(`Timed out after ${ms}ms`));
      }
    }, ms);
    promise.then(
      (value) => {
        if (!settled) {
          settled = true;
          clearTimeout(timer);
          resolve(value);
        }
      },
      (err) => {
        if (!settled) {
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      }
    );
  });
}
